import { render, staticRenderFns } from "./cms-menu-item.vue?vue&type=template&id=2f50bbaf&scoped=true&"
import script from "./cms-menu-item.vue?vue&type=script&lang=js&"
export * from "./cms-menu-item.vue?vue&type=script&lang=js&"
import style0 from "./cms-menu-item.vue?vue&type=style&index=0&id=2f50bbaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f50bbaf",
  null
  
)

export default component.exports